// extracted by mini-css-extract-plugin
export default {"webContentView":"GamesWebContentView__webContentView--xOl"};